export const categories = [
  {
    slug: "yu-le",
    name: "娱乐动态",
    desc: "艺人的公开行程、舞台表现与舆论反馈，只记录公开可查的动态。",
    icon: "ri-mic-line",
    accent: "primary",
  },
  {
    slug: "ying-shi",
    name: "影视综",
    desc: "五一档电影、剧集与综艺的热度走向和口碑变化复盘。",
    icon: "ri-film-line",
    accent: "accent",
  },
  {
    slug: "pin-pai",
    name: "品牌营销",
    desc: "假期节点里的品牌动作，出圈创意与争议操作一并整理。",
    icon: "ri-megaphone-line",
    accent: "secondary",
  },
  {
    slug: "chu-xing",
    name: "出行消费",
    desc: "景区、酒店、交通与价格话题，围绕假期出行体验展开。",
    icon: "ri-route-line",
    accent: "primary",
  },
  {
    slug: "she-jiao",
    name: "社交热点",
    desc: "平台热搜、短视频与直播里被反复讨论的话题与梗。",
    icon: "ri-chat-smile-2-line",
    accent: "accent",
  },
];